import { render, staticRenderFns } from "./OrderAdd.vue?vue&type=template&id=060e9496&"
import script from "./OrderAdd.vue?vue&type=script&lang=js&"
export * from "./OrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdd.vue?vue&type=style&index=0&id=060e9496&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports